import { getCurrencySymbol, getNumberOfCurrencyDigits } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

export type DecimalSeparator = ',' | '.';

@Pipe({ name: 'vfsCurrency' })
export class VfsCurrencyPipe implements PipeTransform {
  transform(value: number, code = '', decimalSeparator: DecimalSeparator = ','): string {
    let locale = decimalSeparator === ',' ? 'de-DE' : 'en-GB';
    if (value) {
      let decimals = code ? getNumberOfCurrencyDigits(code) : 2;
      let numberFormat = value.toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
      return `${numberFormat} ${getCurrencySymbol(code, 'narrow')}`;
    } else {
      return '';
    }
  }
}
